<template>
<!--  <el-backtop style="bottom: 12%;-->
<!--  right: 3%;    z-index: 1000;" />-->
  <!--              :right="100" :bottom="100"-->

    <div class="back-to-top" v-if="showBackToTop" >
      <div class="boxel-icon">
      <el-icon style="color: var(--uavdeep-color);font-size: 20px;" @click="scrollToTop"><CaretTop /></el-icon><br>
      </div>
      <div class="boxel-icon2">
      <el-icon style="color: var(--uavdeep-color);font-size: 20px;" @click="scrollToButtom"><CaretBottom /></el-icon>
      </div>
    </div>

</template>

<script>
export default {
  data() {
    return {
      showBackToTop: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);



  },
  // beforeUnmount() {
  //   window.removeEventListener('scroll', this.handleScroll);
  // },
  methods: {
    handleScroll() {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      // 在这里可以根据 scrollHeight 的值进行相应的判断和处理
      // 例如，判断是否滚动到一定高度并执行相应的操作
      if (scrollHeight > 1) {
        // 执行某些操作
        this.showBackToTop = true;

      }else{
        this.showBackToTop = false;
      }
    },
    scrollToTop() {


      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    scrollToButtom() {
      window.scrollTo(0, document.body.scrollHeight);
    }

  }
};
</script>

<style scoped>

.back-to-top {
  position: fixed;
  bottom: 15%;
  right: 3%;
  padding: 1px;
  width: 40px;
  height: 80px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  border-radius: 40px;
  cursor: pointer;
}

.boxel-icon{
  margin-bottom: 5px;
  background: rgba(255, 255, 255,0.7);
  width: 40px;
  height: 40px;
  border-radius: 40px;


}

.boxel-icon2{

  background: rgba(255, 255, 255,0.7);
  width: 40px;
  height: 40px;
  border-radius: 40px;


}
</style>
